import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { ConfigService, ConfigFileModel } from '@cv-invision/core';
import { Observable } from 'rxjs';
import { Lightbox } from 'ngx-lightbox';

@Component({
	selector: 'cv-invision-photo-card',
	templateUrl: './photo-card.component.html',
	styleUrls: ['./photo-card.component.scss']
})
export class PhotoCardComponent implements OnInit {
	galleryOptions: any[];
	images: any;
	isDisplayingMap: boolean;
	mapCord: any;
	isMain = false;
	loadingPhoto = true;
	gKey: any = null;
	zIndex = 999;

	get configs(): Observable<ConfigFileModel> {
		return this.config.getConfig();
	}

	@Input() info: any;
	@Input() isEditing = false;
	@Input() isSelected = false;
	@Input() address?: string;
	@Input() options?: any;

	/**
	 * emit whether this photo is selected to import
	 */
	@Output() selectedPhoto: EventEmitter<any> = new EventEmitter<any>();

	/**
	 *  emit if the photo is the set to main
	 */
	@Output() setMainPhoto: EventEmitter<any> = new EventEmitter<any>();

	@Output() openGallery: EventEmitter<any> = new EventEmitter<any>();
	constructor(private config: ConfigService, private lightbox: Lightbox) {
		this.isDisplayingMap = false;
	}

	async ngOnInit(): Promise<void> {
		this.galleryOptions = [
			{
				width: '100%',
				height: '256px',
				thumbnails: false,
				lazyLoading: true,
				imageArrows: false,
				previewArrows: false
			}
		];
		const { thumbnails, path, metadata } = this.info;
		this.mapCord = {
			long: metadata.longitude,
			lat: metadata.latitude
		};
		this.images = [
			{
				medium: thumbnails[0],
				big: path
			}
		];
		this.isMain = this.info.metadata.isPrimary;

		const { secrets }: any = await this.configs.toPromise();
		this.gKey = secrets.googleMapsKey;
	}

	/**
	 * put the image as main phot
	 */
	setAsMainPhoto(): void {
		this.isMain = !this.isMain;
		this.setMainPhoto.emit({ isMain: this.isMain, photo: this.info });
	}

	/**
	 * select photo
	 */
	selectPhoto(): void {
		this.isSelected = !this.isSelected;
		this.selectedPhoto.emit({ isSelected: this.isSelected, photo: this.info });
	}

	/**
	 * select photo
	 */
	openBig(): void {
		this.openGallery.emit({ photo: this.info });
	}

	/**
	 * hide map
	 */
	hideMap(): void {
		this.isDisplayingMap = !this.isDisplayingMap;
	}

	/**
	 * tt
	 * @param event
	 */
	onImageLoad(event: any): any {
		this.zIndex = 0;
	}

	/**
	 * on preview image open
	 */
	onPreviewOpen(): void {
		this.zIndex = 0;
	}

	/**
	 * on preview image close
	 */
	onPreviewClose(): void {
		this.zIndex = 1000;
	}

	/**
	 * Show real view of mini map
	 */
	openMap(): void {
		const imgPath = 'https://maps.googleapis.com/maps/api/staticmap?zoom=19&size=640x640&scale=2&markers=color:red%7C' +
			this.info.metadata.latitude + ',' + this.info.metadata.longitude + '&key=' + this.gKey;

		this.lightbox.open([
			{
				src: imgPath,
				caption: '',
				thumb: ''
			}
		], 0);
	}

}
